import { APIRule } from "../types";
import { API_URL } from "../../../../env";

export default async function FetchRulesFromBackend(accountNumber: number): Promise<APIRule[]> {
    const res = await fetch(`${API_URL}/api/v1/trade-rules?account_number=${accountNumber}`);
    if (!res.ok) throw new Error(`Fetch rules failed ${res.status}`);
    return await res.json();
}